import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, MessageSquare, Shield, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const SupportPublic: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border px-4 sm:px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="text-foreground hover:text-foreground/80">
              <ArrowLeft className="h-5 w-5" />
            </Button>
          </Link>
          <h1 className="text-xl sm:text-2xl font-bold text-foreground">
            Suporte
          </h1>
        </div>
      </header>
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 space-y-8">
        {/* Hero Section */}
        <section className="text-center space-y-4">
          <h2 className="text-3xl font-bold text-foreground">
            Como podemos ajudar?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Nossa equipe está pronta para ajudar você com qualquer dúvida ou problema.
          </p>
        </section>

        {/* Contact Options */}
        <div className="grid gap-6 md:grid-cols-2">
          <Card className="bg-card/50 border-border">
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-primary/10">
                  <Mail className="h-5 w-5 text-primary" />
                </div>
                <CardTitle className="text-foreground">Email</CardTitle>
              </div>
              <CardDescription>
                Envie sua mensagem diretamente para nossa equipe
              </CardDescription>
            </CardHeader>
            <CardContent>
              <a 
                href="mailto:contato@interlaced.app" 
                className="text-primary hover:underline font-medium"
              >
                contato@interlaced.app
              </a>
              <p className="text-sm text-muted-foreground mt-2">
                Respondemos em até 24 horas úteis
              </p>
            </CardContent>
          </Card>

          <Card className="bg-card/50 border-border">
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-primary/10">
                  <MessageSquare className="h-5 w-5 text-primary" />
                </div>
                <CardTitle className="text-foreground">Tickets de Suporte</CardTitle>
              </div>
              <CardDescription>
                Abra um ticket para acompanhamento detalhado
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/auth">
                <Button variant="brand-gradient" className="w-full">
                  Fazer login e abrir ticket
                </Button>
              </Link>
              <p className="text-sm text-muted-foreground mt-2">
                Requer conta na plataforma
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Info Cards */}
        <div className="grid gap-4 md:grid-cols-2">
          <div className="flex items-start gap-4 p-4 rounded-lg bg-card/30 border border-border">
            <Clock className="h-5 w-5 text-muted-foreground mt-0.5" />
            <div>
              <h3 className="font-medium text-foreground">Horário de Atendimento</h3>
              <p className="text-sm text-muted-foreground">
                Segunda a Sexta, 9h às 18h (horário de Brasília)
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-4 p-4 rounded-lg bg-card/30 border border-border">
            <Shield className="h-5 w-5 text-muted-foreground mt-0.5" />
            <div>
              <h3 className="font-medium text-foreground">Privacidade Garantida</h3>
              <p className="text-sm text-muted-foreground">
                Suas informações são tratadas com total confidencialidade
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Link */}
        <section className="text-center pt-8 border-t border-border">
          <p className="text-muted-foreground mb-4">
            Antes de entrar em contato, consulte também:
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/terms">
              <Button variant="outline">Termos de Uso</Button>
            </Link>
            <Link to="/privacy">
              <Button variant="outline">Política de Privacidade</Button>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default SupportPublic;
